import { render, staticRenderFns } from "./selectType.vue?vue&type=template&id=33705102&scoped=true&"
import script from "./selectType.vue?vue&type=script&lang=js&"
export * from "./selectType.vue?vue&type=script&lang=js&"
import style0 from "./selectType.vue?vue&type=style&index=0&id=33705102&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33705102",
  null
  
)

export default component.exports